module.exports = __webpack_public_path__ + "static/img/4核心算法-off.ac8f772.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/4核心算法-off.png
// module id = xKzs
// module chunks = 0